<template>
  <div class="exception-body">
    <div class="exception-code">
      <strong>{{code}}</strong>
    </div>
    <div class="exception-message">
      <h3>{{meaasge}}
        <div v-if="form && form.path && form.path !== '/'">
          <router-link style="
            text-decoration: none;
            color: #DCDFE6;
            line-height: 22px;
            font-size: 12px;
            font-weight: normal;"
                       :to="form.fullPath">{{form.name}} {{form.path}}
          </router-link>
        </div>
      </h3>
    </div>
    <div>
      <el-button-group>
        <el-button type="primary"
                   round
                   size="medium"
                   @click="$router.push('/')">首页
        </el-button>
        <el-button type="primary"
                   round
                   size="medium"
                   @click="$router.go(-2)">返回上一页
        </el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    code: [Number, String],
    meaasge: String,
    form: Object,
  },
}
</script>

<style lang="scss"
       src="./exception.scss"></style>



// WEBPACK FOOTER //
// core/pages/exception/Exception.vue